import { h } from "@stencil/core";
const render = () => (h("iframe", { src: "/showcase/pages/paginator.html", frameborder: "0" }));
export const paginatorShowcaseStory = {
    render: render
};
